import { render, staticRenderFns } from "./LatestSocialPosts.vue?vue&type=template&id=45867353&"
import script from "./LatestSocialPosts.vue?vue&type=script&lang=js&"
export * from "./LatestSocialPosts.vue?vue&type=script&lang=js&"
import style0 from "./LatestSocialPosts.vue?vue&type=style&index=0&id=45867353&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports